import CriticsAddActions from "components/Critics/AddActions"

import { ComponentProps } from "."

const AddActions = ({
  IMDb,
  contentAuthors,
  imageSelector,
  screenshotSelector,
  isAddNewsEnabled,
  isAdmin,
  isEditor,
  isSingleSource,
  label,
  loading,
  name,
  onAddNews,
  onClearAll,
  onContentAuthorSelect,
  onNameChange,
  onSetReleaseDate,
  releaseDate,
  searchHomeVideo,
  searchNewsSource
}: ComponentProps) => (
  <CriticsAddActions
    IMDb={IMDb}
    contentAuthors={contentAuthors}
    gridTemplateColumns={isSingleSource ? "1fr 1fr 1fr" : "1fr 1fr"}
    imageSelector={{ ...imageSelector, isMultiSelect: true }}
    isAddItemEnabled={isAddNewsEnabled}
    isAdditionalInstructions
    isAdmin={isAdmin}
    isEditor={isEditor}
    isSingleSource={isSingleSource}
    label={label}
    loading={loading}
    name={name}
    onAddItem={onAddNews}
    onClearAll={onClearAll}
    onContentAuthorSelect={onContentAuthorSelect}
    onNameChange={onNameChange}
    onSetReleaseDate={onSetReleaseDate}
    releaseDate={releaseDate}
    screenshotSelector={
      screenshotSelector
        ? { ...screenshotSelector, isMultiSelect: true }
        : undefined
    }
    searchHomeVideo={searchHomeVideo}
    searchNewsSource={searchNewsSource}
    serviceType="news"
  />
)

export default AddActions
